import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DateAdapter } from '@angular/material/core';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private readonly STORAGE_KEY = 'app_lang';

  constructor(private translate: TranslateService,
              private dateAdapter: DateAdapter<Date>) {}

  init(): void {
    const browserLang = this.translate.getBrowserLang();
    const savedLang = localStorage.getItem(this.STORAGE_KEY);

    const langToUse = savedLang || (browserLang?.match(/en|it/) ? browserLang : 'en');

    this.setLanguage(langToUse);
  }

  setLanguage(lang: string): void {
    localStorage.setItem(this.STORAGE_KEY, lang);
    this.translate.use(lang);

    const locale = lang === 'it' ? 'it-IT' : 'en-US';
    this.dateAdapter.setLocale(locale);
  }

  getCurrentLang(): string {
    return this.translate.currentLang || 'en';
  }

  getTranslationMenu(key: string): string {

    if (key == 'Devices.ClientPosition')
      return this.translate.instant(key);

    const translation = this.translate.instant(`Menu.${key}`);
    if (translation.startsWith('Menu.'))
      return translation.replace('Menu.', '');
    return translation;
  }

  getTranslation(key: string): string {
    return this.translate.instant(key);
  }
}